import React from "react";
import { Link } from "react-router-dom";

export default function ShippingReturns() {
  return (
    <div className="container-lookers py-16 max-w-2xl" data-testid="shipping-returns-page">
      <h1 className="font-serif text-5xl mb-8 text-zinc-900">
        Shipping &amp; Returns
      </h1>
      <section className="mb-10">
        <h2 className="font-heading text-xs uppercase tracking-wide mb-3 text-teal-700">Shipping</h2>
        <p className="text-sm text-zinc-500 leading-relaxed mb-2">Free standard shipping on orders over $150 within Australia. Every order is tracked from the moment it leaves us. Express shipping is available at checkout for a faster turnaround.</p>
        <p className="text-sm text-zinc-500 leading-relaxed">Perth customers can also choose free pickup from our studio where available.</p>
      </section>
      <section>
        <h2 className="font-heading text-xs uppercase tracking-wide mb-3 text-teal-700">Returns</h2>
        <p className="text-sm text-zinc-500 leading-relaxed mb-2">Simple 14-day returns if a pair isn't right for you. Frames must be returned in the condition they were sent, with any original packaging included.</p>
        <p className="text-sm text-zinc-500 leading-relaxed">Have a question about your order? <Link to="/how-it-works" className="underline text-teal-700">See how it works</Link> or reach out to our customer care team.</p>
      </section>
    </div>
  );
}
